import { createSlice } from "@reduxjs/toolkit";

const customerSlice = createSlice({
    name: "customer",
    initialState: {
        customers: {
            allCustomers: [],
            isFetching: false,
            error: false,
        },
        detail: {
            currentCustomer: null,
            isFetching: false,
            error: false,
        },
        create: {
            isFetching: false,
            error: false,
            success: false,
        },
        update: {
            isFetching: false,
            error: false,
            success: false,
        },
        delete: {
            isFetching: false,
            error: false,
            success: false,
        },
    },
    reducers: {
        getCustomersStart: (state) => {
            state.customers.isFetching = true;
        },
        getCustomersSuccess: (state, action) => {
            state.customers.isFetching = false;
            state.customers.allCustomers = action.payload;
            state.customers.error = false;
        },
        getCustomersFailed: (state) => {
            state.customers.isFetching = false;
            state.customers.error = true;
        },
        getCustomerStart: (state) => {
            state.detail.isFetching = true;
        },
        getCustomerSuccess: (state, action) => {
            state.detail.isFetching = false;
            state.detail.currentCustomer = action.payload;
            state.detail.error = false;
        },
        getCustomerFailed: (state) => {
            state.detail.isFetching = false;
            state.detail.error = true;
        },
        createCustomerStart: (state) => {
            state.create.isFetching = true;
        },
        createCustomerSuccess: (state, action) => {
            state.create.isFetching = false;
            state.create.success = true;
            state.customers.allCustomers.push(action.payload);
        },
        createCustomerFailed: (state) => {
            state.create.isFetching = false;
            state.create.error = true;
            state.create.success = false;
        },
        updateCustomerStart: (state) => {
            state.update.isFetching = true;
        },
        updateCustomerSuccess: (state, action) => {
            state.update.isFetching = false;
            state.update.success = true;
            const index = state.customers.allCustomers.findIndex(
                (item) => item._id === action.payload._id
            );
            if (index !== -1) {
                state.customers.allCustomers[index] = action.payload;
            }
        },
        updateCustomerFailed: (state) => {
            state.update.isFetching = false;
            state.update.error = true;
            state.update.success = false;
        },
        deleteCustomerStart: (state) => {
            state.delete.isFetching = true;
        },
        deleteCustomerSuccess: (state, action) => {
            state.delete.isFetching = false;
            state.delete.success = true;
            state.customers.allCustomers = state.customers.allCustomers.filter(
                (item) => item._id !== action.payload
            );
        },
        deleteCustomerFailed: (state) => {
            state.delete.isFetching = false;
            state.delete.error = true;
            state.delete.success = false;
        },
    },
});

export const {
    getCustomersStart,
    getCustomersSuccess,
    getCustomersFailed,
    getCustomerStart,
    getCustomerSuccess,
    getCustomerFailed,
    createCustomerStart,
    createCustomerSuccess,
    createCustomerFailed,
    updateCustomerStart,
    updateCustomerSuccess,
    updateCustomerFailed,
    deleteCustomerStart,
    deleteCustomerSuccess,
    deleteCustomerFailed,
} = customerSlice.actions;

export default customerSlice.reducer;

